import { CalendarDate, DateValue, parseDate } from "@internationalized/date";
import { RangeValue } from "@react-types/shared";
import { format } from "date-fns";

export function convertCalendarDateToDate(calendarDate: CalendarDate): Date {
  return new Date(calendarDate.year, calendarDate.month - 1, calendarDate.day);
}

export function convertDateToCalendarDate(date: Date): CalendarDate {
  return new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

export function convertDateRangeFilterToRangeValue(dateRange: string): RangeValue<DateValue> {
  const [start, end] = dateRange.split(",").map(date => parseDate(date));
  return { start, end };
}

export function convertRangeValueToDateRangeFilter(dateRange: RangeValue<DateValue>): string {
  const start = dateRange.start.toString();
  const end = dateRange.end.toString();

  return `${start},${end}`;
}

export function convertDatesToDateRange(dates: [Date, Date]): string {
  return dates.map(date => format(date, "yyyy-MM-dd")).join(",");
}

export function validateDateRangeValue(dateRange?: RangeValue<DateValue>, limits?: RangeValue<DateValue>): boolean {
  try {
    if (!dateRange || !dateRange?.start || !dateRange?.end) return false;

    const { start, end } = dateRange;

    const startDate = new CalendarDate(start.year, start.month, start.day);
    const endDate = new CalendarDate(end.year, end.month, end.day);

    if (startDate.compare(endDate) > 0) return false;

    if (limits?.start && startDate.compare(limits.start) < 0) return false;
    if (limits?.end && endDate.compare(limits.end) > 0) return false;

    return true;
  } catch {
    return false;
  }
}
